export default "__VITE_ASSET__dzlRdAAw__"